import React from 'react';
import cc from 'classcat';
import { NextPageContext } from 'next';

import { Breadcrumbs, HeroStatic } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import { postDate } from '../../../lib/PostDate';
import ErrorPage from '../../_error';
import NotFoundPage from '../../404';

import query from './index.graphql';

import styles from './index.module.scss';

interface Props {
  slug: string;
}

const InformationGuidePage = ({ slug }: Props) => {
  const [{ data, error }] = useSiteQuery<InformationGuidesQuery>({ query, variables: { slug } });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;
  if (entry) {
    const title = entry.title!;
    const uri = entry.uri!;
    const heroImage = entry.heroImage;

    const breadcrumbs: BreadcrumbItem[] = [
      {
        title: 'Help Centre',
        uri: '/help-centre',
      },
      { title, uri },
    ];

    return (
      <div>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        {heroImage && (
          <HeroStatic photos={heroImage} title={title}>
            <div className="sectionHeading">Information Guides</div>
            <h1 className="heroH1" data-test-id="customTitle">
              {title}
            </h1>
            <span className={cc(['postDate', styles.postDate])}>{postDate(entry.postDate!)}</span>
            <p className="mt-1 mt-lg-2 heroHeadline" dangerouslySetInnerHTML={{ __html: entry.description! }} />
          </HeroStatic>
        )}
        <div className="section">
          <div className="container">
            <div className="articleBody">
              <div dangerouslySetInnerHTML={{ __html: entry.body! }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <NotFoundPage />;
};

InformationGuidePage.getInitialProps = ({ req }: NextPageContext) => ({
  slug: req?.url?.substring(req?.url?.lastIndexOf('/') + 1).replace(/\?.*$/, ''),
});

export default InformationGuidePage;
